import React, { useEffect, useState } from 'react';

import styles from './index.module.scss';

import LegalLine from '../LegalLine/LegalLine';

interface TemplateFullProps {
  heightFull?: boolean;
  children: React.ReactNode;
  type?: 'default' | 'alert';
  legalLine?: 'simple' | 'full';
}

const TemplateFull: React.FC<TemplateFullProps> = ({ children, heightFull = false, type = 'default', legalLine = 'full' }) => {
  return (
    <div className={`${styles.TemplateFull} ${type === 'alert' ? styles.alert : ''}`}>
      <div className={styles.wrapper}>
        <div className={`${styles.content} ${heightFull ? styles.heightFull : ''}`}>
          { children }
        </div>
        <LegalLine color="white" type={legalLine}/>
      </div>
    </div>
  );
};

export default TemplateFull; 